import { AUTOMATION_ACTION_TYPES } from '../../automation/constants/actionTypes';

const SUPPORTED_BULK_ACTIONS = [
    'add_label',
    'remove_label',
    'assign_agent',
    'unassign_agent',
    'assign_team',
    'remove_assigned_team',
    'resolve_conversation',
    'change_priority',
    'send_message',
    'send_event_log',
];

export const BULK_ACTION_TYPES = AUTOMATION_ACTION_TYPES.filter(action => {
    return SUPPORTED_BULK_ACTIONS.includes(action.key);
});
